import { InferenceStore } from 'store/inference/InferenceStore'
import ProfileStore from 'store/profile/ProfileStore'
import { store } from 'store/store'

function findProfileInner(inference: InferenceStore, has: boolean): ProfileStore | undefined {
  const { identity_id, complete } = inference
  if (!complete) return

  const full = store.identities.profiles.find(it => it.identity_id
    && it.identity_id === identity_id && it.type === 'full')
  if (!full) return

  const { url } = full.common.userPhoto
  if (!url) return

  const params = new URL(url, location.origin).searchParams
  return params.has('measurements') === has ? full : undefined
}

export function needMeasurements(inference: InferenceStore): ProfileStore | undefined {
  return findProfileInner(inference, false)
}

export function hasMeasurements(inference: InferenceStore): ProfileStore | undefined {
  return findProfileInner(inference, true)
}

export function findFullProfile(inference: InferenceStore): ProfileStore | undefined {
  const { identity_id, complete } = inference
  if (!complete) return

  return store.identities.profiles.find(it => it.identity_id
    && it.identity_id === identity_id && it.type === 'full')

}

export function hasMeasurementsParam(url: string | undefined): boolean {
  if (!url) return false
  const value = new URL(url, location.origin)
  return value.searchParams.has('measurements')
}
